import { createAction, createSetterActions } from "@/redux/helpers/action";

import { MODULE } from "./constants";

// Simple setter actions (dispatch with value)
export const [setIsPrinting, setIsGeneratingPdfStatus] = createSetterActions(MODULE, [
  "isPrinting",
  "isGeneratingPdfStatus",
]);

// Custom actions
export const reset = createAction(`${MODULE}/RESET`);
